export default "__VITE_ASSET__g12l0lSS__"